import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Box,
  Container,
  Grid,
  Skeleton,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import DetailTemplate from "./detailTemplate";
import DetailTemplateFinancial from "./DetailTemplateFinancial";
import { getLoanTemplateInfo } from "../../services/loanTemplate.service";
import {
  GetLoanTemplateInfoResponse,
  LoanTemplateIdRequest,
} from "../../models/loanTemplate.model";
import DetailTemplateGuarantee from "./DetailTemplateGuarantee";
import DetailTemplateDocumentType from "./DetailTemplateDocumentType";
import DetailTemplateConnectedSuppliers from "./DetailTemplateConnectedSuppliers";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ModalNotification from "../../components/modals/ModalNotification";
import DetailTemplateInquiry from "./DetailTemplateInquiry";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1350,
      xl: 1536,
    },
  },
});

const FinancialSupplierDetail = () => {

  const history = useHistory<any>();
  const [loanTemplate, setLoanTemplate] = useState<
    GetLoanTemplateInfoResponse
  >();
  const id = localStorage.getItem("FinancialSupplier_ID");
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [sendConfirmation, setSendConfirmation] = React.useState(false);
  const [flagModal, setFlagModal] = React.useState();

  function ReceiverConnection() {
    setOpenVerifyModal(true);
  }

  const getLoanTemplateInfoMutation = useMutation(getLoanTemplateInfo, {
    onSuccess: (data: GetLoanTemplateInfoResponse) => {
      if (data) {
        setLoanTemplate(data);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    if (history.action === "POP") {
      history.push({
        pathname: "/FinancialSupplier1/FinancialSupplierDetailList",
        // state: { id: JSON.parse(localStorage.getItem("FinancialSupplier_ID")!) },
        state: { id: Number(id) },
      });
    }
  }, [history, id]);

  useEffect(() => {
    if (history.action === "PUSH") {
      let loanTemplateId = {} as LoanTemplateIdRequest;
      loanTemplateId.id = Number(id);
      getLoanTemplateInfoMutation.mutate(loanTemplateId);
      history.push({
        pathname:
          "/FinancialSupplier1/FinancialSupplierDetailList1/FinancialSupplierDetail",
        state: { id: Number(id) },
      });
    }
  }, [history, id]);

  useEffect(() => {
    let loanTemplateId = {} as LoanTemplateIdRequest;
    loanTemplateId.id = Number(id);
    getLoanTemplateInfoMutation.mutate(loanTemplateId);
  }, [flagModal]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <div>
          {/* supplier card detail info */}
          <Grid
            container
            xs={12}
            columns={{ xs: 4, sm: 8, md: 12 }}
            marginBottom={"4rem"}
          >
            <Grid item xs={12}>
              <Box
                sx={{
                  backgroundColor: "rgba(154,175,196,0.15)",
                  borderRadius: "5px",
                }}
                paddingY={"1rem"}
              >
                <Grid
                  container
                  xs={12}
                  justifyContent={"right"}
                  alignItems={"center"}
                >
                  <Grid
                    item
                    xs={12}
                    md={3}
                    sm={12}
                    lg={2}
                    xl={2}
                    textAlign={{ lg: "center", xl: "center" }}
                    style={{ width: "100%" }}
                  >
                    {loanTemplate?.cardImage ? (
                      <img
                        className="activePlansCardImg"
                        src={`data:image/png;base64,${loanTemplate?.cardImage}`}
                        alt=""
                      />
                    ) : (
                      <Skeleton
                        variant="rectangular"
                        width={140}
                        height={75}
                        animation={false}
                        sx={{
                          // marginLeft: "0.5rem",
                          borderRadius: "5px",
                        }}
                      ></Skeleton>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sm={12}
                    lg={6}
                    xl={6}
                    top={{
                      md: "10px",
                      lg: "10px",
                      sm: "10px",
                      xs: "10px",
                      xl: "0px",
                    }}
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        color: "#1D4A87",
                        fontSize: "18px",
                        fontWeight: "bold",
                        bottom: "5px",
                        position: "relative",
                      }}
                    >
                      {loanTemplate?.loanTemplateTitle}
                    </span>
                    <br />
                    <span
                      style={{
                        backgroundColor: "#1D4A87",
                        borderRadius: "3px",
                        color: "#fff",
                        paddingRight: "7px",
                        paddingLeft: "7px",
                        position: "relative",
                        top: "5px",
                      }}
                    >
                      {loanTemplate?.financialSupplierTitle}
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    maxWidth={{ xl: "15%", lg: "fit-content" }}
                    textAlign={{
                      lg: "center",
                      xl: "center",
                      md: "end",
                      sm: "end",
                      xs: "end",
                    }}
                    style={{
                      width: "100%",
                      paddingLeft: "5px",
                    }}
                  >
                    {loanTemplate?.clonePermission ? (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          ReceiverConnection();
                        }}
                      >
                        <AddCircleOutlineIcon
                          sx={{
                            marginLeft: "5px",
                            color: "#1D4A87",
                          }}
                        ></AddCircleOutlineIcon>
                        <span
                          style={{ color: "#1D4A87", whiteSpace: "nowrap" }}
                        >
                          اتصال پذیرنده به طرح
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    style={{ maxWidth: "fit-content" }}
                    visibility={{
                      md: "hidden",
                      sm: "hidden",
                      xs: "hidden",
                      lg: "visible",
                      xl: "visible",
                    }}
                  >
                    <span
                      style={{
                        color: "#CFD8DC",
                        marginRight: "10px",
                        marginLeft: "10px",
                      }}
                    >
                      |
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    maxWidth={{ xl: "15%", lg: "fit-content" }}
                    textAlign={{
                      lg: "center",
                      xl: "center",
                      md: "end",
                      sm: "end",
                      xs: "end",
                    }}
                    style={{
                      width: "100%",
                      paddingLeft: "5px",
                    }}
                  >
                    {loanTemplate?.clonePermission ? (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          history.push({
                            pathname:
                              "/FinancialSupplier1/FinancialSupplierDetailList1/FinancialSupplierDetail1/LoanTemplateInfo",
                            state: { id: Number(id), props: loanTemplate },
                          });
                          // localStorage.setItem(
                          //     "FinancialSupplier_ID",
                          //     JSON.stringify(id)
                          // );
                        }}
                      >
                        <ContentCopyIcon
                          sx={{
                            marginLeft: "5px",
                            color: "#1D4A87",
                          }}
                        ></ContentCopyIcon>
                        <span
                          style={{ color: "#1D4A87", whiteSpace: "nowrap" }}
                        >
                          ایجاد طرح تسهیلاتی مشابه
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  {/* <Grid item lg={1}></Grid> */}
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            xs={12}
            columns={{ xs: 4, sm: 8, md: 12 }}
            style={{ paddingBottom: "5vh" }}
          >
            <DetailTemplate data={loanTemplate?.loanTemplateSpecification} />
          </Grid>
          {loanTemplate?.installmentSteps?.length! > 0 ? (
            <Grid
              container
              xs={12}
              columns={{ xs: 4, sm: 8, md: 12 }}
              style={{ paddingBottom: "5vh" }}
            >
              <DetailTemplateFinancial
                title={"طول دوره بازپرداخت"}
                data={loanTemplate?.installmentSteps}
                cardImage={loanTemplate?.cardImage}
              />
            </Grid>
          ) : (
            ""
          )}
           {loanTemplate?.inquiryTypes?.length! > 0 ? (
            <Grid
              container
              xs={12}
              columns={{ xs: 4, sm: 8, md: 12 }}
              style={{ paddingBottom: "5vh" }}
            >
              <DetailTemplateInquiry
                title={"لیست استعلام های مورد نیاز:"}
                data={loanTemplate?.inquiryTypes}
              />
            </Grid>
          ) : (
            ""
          )}
          {loanTemplate?.loanTemplateGuaranteeType?.length! > 0 ? (
            <Grid
              container
              xs={12}
              columns={{ xs: 4, sm: 8, md: 12 }}
              style={{ paddingBottom: "5vh" }}
            >
              <DetailTemplateGuarantee
                title={"ضمانت های طرح"}
                data={loanTemplate?.loanTemplateGuaranteeType}
              />
            </Grid>
          ) : (
            ""
          )}
          {loanTemplate?.documentTypes?.length! > 0 ? (
            <Grid
              container
              xs={12}
              columns={{ xs: 4, sm: 8, md: 12 }}
              style={{ paddingBottom: "5vh" }}
            >
              <DetailTemplateDocumentType
                title={"مستندات مورد نیاز"}
                data={loanTemplate?.documentTypes}
              />
            </Grid>
          ) : (
            ""
          )}
          {loanTemplate?.connectedSuppliers?.length! > 0 ? (
            <Grid
              container
              xs={12}
              columns={{ xs: 4, sm: 8, md: 12 }}
              style={{ paddingBottom: "5vh" }}
            >
              <DetailTemplateConnectedSuppliers
                title={"پذیرندگان متصل به طرح"}
                data={loanTemplate?.connectedSuppliers}
              />
            </Grid>
          ) : (
            ""
          )}
          <ModalNotification
            openModel={openVerifyModal}
            setSendConfirmation={setSendConfirmation}
            setOpenVerifyModal={setOpenVerifyModal}
            supplierSettlementRequestKeys={true}
            settlementAmount={true}
            loanTemplateId={id}
            setFlagModal={setFlagModal}
          />
        </div>
      </ThemeProvider>
    </>
  );
};

export default FinancialSupplierDetail;
